(function () {
    'use strict';
    $(window).on('resize', function (evt) {
        resizeStickyTable();
    });
    $(window).on('resizeStickyTable', function (evt) {
        resizeStickyTable();
    });
    $(document).ready(function () {
    });

    function resizeStickyTable() {
        // setTimeout(function () {
        //     try {
        //         var stickyTable = $('.table-fixed-header .sticky-table');
        //         var offset = stickyTable.offset().top + $('.results-grid-paginator').height();
        //         stickyTable.css('max-height', 'calc(100vh - ' + offset + 'px)');
        //     } catch (e) { }
        // }, 20);
    }
})();